import { useRemoteData } from "../hooks/useRemoteData"
import { Link } from "react-router-dom"
import NavBar from "../components/NavBar"
import { fetchUsers } from "../api/users"

export default function UsersPage() {
  const { data, loading, error: failed } = useRemoteData(fetchUsers)
  const users = data || []
  const error = failed ? "Unable to load users. Please try again." : null

  function renderDirectory() {
    if (loading) {
      return <p className="text-sm text-gray-500">Loading...</p>
    }
    if (error) {
      return <p className="text-sm text-red-500">{error}</p>
    }
    if (users.length === 0) {
      return (
        <div className="bg-white rounded-xl shadow-sm p-6">
          <p className="text-sm text-gray-500">No other users yet.</p>
        </div>
      )
    }
    return (
      <div className="bg-white rounded-xl shadow-sm divide-y divide-gray-100">
        {users.map((user) => (
          <Link
            key={user.id}
            to={`/users/${user.id}`}
            className="flex items-center justify-between px-6 py-4 hover:bg-gray-50 transition-colors"
          >
            <span className="text-sm font-medium text-gray-900">
              {user.name}
            </span>
            <span className="text-xs text-gray-400">View list →</span>
          </Link>
        ))}
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <NavBar />

      <main className="max-w-2xl mx-auto px-4 py-8">
        <div className="flex items-center gap-3 mb-6">
          <Link
            to="/dashboard"
            className="text-sm text-gray-500 hover:text-gray-900 transition-colors"
          >
            ← Back
          </Link>
          <h2 className="text-lg font-semibold text-gray-900">Find a list</h2>
        </div>

        {renderDirectory()}
      </main>
    </div>
  )
}
